import addEmailAddressDialogTemplate from './addEmailAddressDialog.template.html';

/*****************************************************************************
 * Service: addEmailAddressDialog */
/**
 * @ngdoc  service
 * @module StoreAccountManagement
 * @name   StoreAccountManagement.service:addEmailAddressDialog
 * @description
 * Utility to show a dialog for adding an email address
 *****************************************************************************/
/* @ngInject */ export function AddEmailAddressDialogService($uibModal) {
  /***************************************************************************
   * Properties
   ***************************************************************************/
  /** Self reference. */ var mThis = this;

  /***************************************************************************
   * show */
  /**
   * @ngdoc     method
   * @module    storeAccountManagement
   * @methodOf  storeAccountManagement.service:addEmailAddressDialog
   * @param     {object}  entity   Entity to add an email address to.
   * @description
   * Show the modal dialog for adding an email address
   ***************************************************************************/
  mThis.show = function (entity) {
    return $uibModal.open({
      animation: false,
      backdrop: 'static',
      controller: addEmailAddressController,
      resolve: {
        entity: function () {
          return entity;
        }
      },
      size: 'md',
      template: addEmailAddressDialogTemplate
    }).result;
  };

  /***************************************************************************
   * addEmailAddressController
   **
    * Opens a modal for the user to add an email address for the selected user.
    * This is called when the user does not already have an email address
    * assgined to them.
    *
    * @params entity  Selected entity
    ***************************************************************************/
  function addEmailAddressController($scope, entity) {
    $scope.entity = entity;
    $scope.valGroup = {};

    /*-------------------------*/
    /* Display name for header */
    /*-------------------------*/
    $scope.registerName = 'Register  ' + entity.displayName;

    /*************************************************************************
     * close
     *
     * Close the modal and pass the entity information back to the function
     * that called the that called this dialog.
     *************************************************************************/
    $scope.close = function () {
      /*----------------------------*/
      /* Validate the email address */
      /*----------------------------*/
      if (!$scope.valGroup.validate()) return;

      $scope.$close($scope.entity);
    };
  }
}
